/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 20,
    height: 25,
    viewBox: '0 0 20 25',
    data: '<path pid="0" d="M9.864 12.867l2.752-2.751.732.733-2.75 2.751 2.75 2.752-.732.732-2.752-2.75-2.75 2.75-.734-.732L9.131 13.6l-2.75-2.751.732-.733 2.751 2.751zm-2.917-9.7h5.835V1.696H6.947v1.47zm-1.036 0V1.535c0-.484.392-.876.875-.876h6.156c.484 0 .876.392.876.876v1.632h5.373v1.036h-1.155v17.995a1.836 1.836 0 0 1-1.835 1.836H3.528a1.836 1.836 0 0 1-1.836-1.836V4.203H.537V3.167h5.374zM2.729 4.203v17.995a.8.8 0 0 0 .8.799H16.2a.8.8 0 0 0 .799-.8V4.204H2.729z" _fill="#454545" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/trash.js